import { render } from "./BorrowerTaskCard.vue?vue&type=template&id=daba55ba&scoped=true"
import script from "./BorrowerTaskCard.vue?vue&type=script&lang=js"
export * from "./BorrowerTaskCard.vue?vue&type=script&lang=js"

import "@/assets/css/commandcenter/commandcenter.css?vue&type=style&index=0&lang=css&external"
import "./BorrowerTaskCard.vue?vue&type=style&index=1&id=daba55ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daba55ba"]])

export default __exports__